import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {screenSizeSmaller} from 'views/components';

import NavbarBigScreen from './navbar_big_screen';
import NavbarSmallScreen from './navbar_small_screen';

import SERVICES from './ServicesConfig';

const NavBar = (props) => {
  const mobileApp = props.mobileApp;

  const smallScreen = screenSizeSmaller('navbarHide');

  if (mobileApp) {
    // Don't show on mobile app
    return null;
  }


  if (smallScreen) {
    return (
      <NavbarSmallScreen
        services={SERVICES}
      />
    );
  }

  return (
    <NavbarBigScreen
      services={SERVICES}
    />
  );
};


NavBar.propTypes = {
  mobileApp: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  mobileApp: state.environment.mobileApp,
});

export default connect(mapStateToProps, dispatch)(React.memo(NavBar));
